import React, { useEffect, useState } from "react"
import { Button, Col, Modal } from "react-bootstrap"
import ModalDebrisIndex from "./Modal/ModalDebrisIndex";
import Swal from "sweetalert2";
import swal from "sweetalert";
import { API } from "../../../../config/api";


export default function OdontogramDebrisIndex({
    formchoiceGigi,
    toothShapes,
    customToothShapes,
    renderToothPolygonDebrisIndex,
    onDataChange,
    setDebrisPerTooth,
    onChangeDebrisPerTooth,
    toothPosition,
    onDebrisChange
}) {

    const [visibleOdontogram, setVisibleOdontogram] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedTooth, setSelectedTooth] = useState(null);
    const [positionTooth, setPositionTooth] = useState(null);
    const [coloredTeeth, setColoredTeeth] = useState([]);
    const [getDebrisIndex, setGetDebrisIndex] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pages, setPages] = useState();
    const [ascending] = useState(0);
    const [rows, setRows] = useState(1);
    const [keyword, setKeyword] = useState("");
    const [query, setQuery] = useState("");
    const [msg, setMsg] = useState("");
    const token = localStorage.getItem("token");
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);


    const [getDataChoiceDebrisIndex, setGetDataChoiceDebrisIndex] = useState([]);


    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };

    const [getDataDebrisIndex, setGetDataDebrisIndex] = useState([]);


    const GetResponseDataDebrisIndex = async () => {
        try {
            setLoading(true);
            const response = await API.get(`/emr-service/debris-index?page=${page}&limit=${limit}&ascending=${ascending}`, fetchParams);
            if (response?.status === 200) {
                const debrisData = response.data.data;
                setGetDataDebrisIndex(debrisData);
                setLoading(false);

                // Kirim semua data ke parent
                if (onDataChange) {
                    onDataChange(debrisData);
                }
            }
        } catch (error) {
            setLoading(false);
            swal({
                title: 'Failed',
                text: `${error.response?.data?.message || 'Something went wrong'}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    };


    useEffect(() => {
        GetResponseDataDebrisIndex()
    }, [page])


    // Definisikan semua kelompok gigi di dalam fungsi
    const TOOTH_SETS = {
        ra_rb_full: [
            "18", "17", "16", "15", "14", "13", "12", "11", "21", "22", "23", "24",
            "25", "26", "27", "28",
            "55", "54", "53", "52", "51", "61", "62", "63", "64", "65",
            "85", "84", "83", "82", "81", "71", "72", "73", "74", "75",
            "48", "47", "46", "45", "44", "43", "42", "41",
            "31", "32", "33", "34", "35", "36", "37", "38"
        ],
        ra_rb_dewasa: [
            "18", "17", "16", "15", "14", "13", "12", "11",
            "21", "22", "23", "24", "25", "26", "27", "28",
            "48", "47", "46", "45", "44", "43", "42", "41",
            "31", "32", "33", "34", "35", "36", "37", "38"
        ],
        ra_rb_anak: [
            "55", "54", "53", "52", "51", "61", "62", "63", "64", "65",
            "85", "84", "83", "82", "81", "71", "72", "73", "74", "75"
        ],
        ra_dewasa_anak: [
            "18", "17", "16", "15", "14", "13", "12", "11",
            "21", "22", "23", "24", "25", "26", "27", "28",
            "55", "54", "53", "52", "51", "61", "62", "63", "64", "65"
        ],
        ra_dewasa: [
            "18", "17", "16", "15", "14", "13", "12", "11",
            "21", "22", "23", "24", "25", "26", "27", "28"
        ],
        ra_anak: [
            "55", "54", "53", "52", "51", "61", "62", "63", "64", "65"
        ],
        rb_dewasa_anak: [
            "85", "84", "83", "82", "81", "71", "72", "73", "74", "75",
            "48", "47", "46", "45", "44", "43", "42", "41",
            "31", "32", "33", "34", "35", "36", "37", "38"
        ],
        rb_dewasa: [
            "48", "47", "46", "45", "44", "43", "42", "41",
            "31", "32", "33", "34", "35", "36", "37", "38"
        ],
        rb_anak: [
            "85", "84", "83", "82", "81", "71", "72", "73", "74", "75"
        ],
        regio_1: ["18", "17", "16", "15", "14", "13", "12", "11"],
        regio_2: ["21", "22", "23", "24", "25", "26", "27", "28"],
        regio_3: ["31", "32", "33", "34", "35", "36", "37", "38"],
        regio_4: ["48", "47", "46", "45", "44", "43", "42", "41"],
        regio_5: ["55", "54", "53", "52", "51"],
        regio_6: ["61", "62", "63", "64", "65"],
        regio_7: ["71", "72", "73", "74", "75"],
        regio_8: ["85", "84", "83", "82", "81"]
    };

    const TOOTH_POSITIONS = {
        "18": "Structure of permanent maxillary right third molar tooth",
        "17": "Structure of permanent maxillary right second molar tooth",
        "16": "Structure of permanent maxillary right first molar tooth",
        "15": "Structure of permanent maxillary right second premolar tooth",
        "14": "Structure of permanent maxillary right first premolar tooth",
        "13": "Structure of permanent maxillary right canine tooth",
        "12": "Structure of permanent maxillary right lateral incisor tooth",
        "11": "Structure of permanent maxillary right central incisor tooth",

        "21": "Structure of permanent maxillary left central incisor tooth",
        "22": "Structure of permanent maxillary left lateral incisor tooth",
        "23": "Structure of permanent maxillary left canine tooth",
        "24": "Structure of permanent maxillary left first premolar tooth",
        "25": "Structure of permanent maxillary left second premolar tooth",
        "26": "Structure of permanent maxillary left first molar tooth",
        "27": "Structure of permanent maxillary left second molar tooth",
        "28": "Structure of permanent maxillary left third molar tooth",

        "31": "Structure of permanent mandibular left central incisor tooth",
        "32": "Structure of permanent mandibular left lateral incisor tooth",
        "33": "Structure of permanent mandibular left canine tooth",
        "34": "Structure of permanent mandibular left first premolar tooth",
        "35": "Structure of permanent mandibular left second premolar tooth",
        "36": "Structure of permanent mandibular left first molar tooth",
        "37": "Structure of permanent mandibular left second molar tooth",
        "38": "Structure of permanent mandibular left third molar tooth",

        "41": "Structure of permanent mandibular right central incisor tooth",
        "42": "Structure of permanent mandibular right lateral incisor tooth",
        "43": "Structure of permanent mandibular right canine tooth",
        "44": "Structure of permanent mandibular right first premolar tooth",
        "45": "Structure of permanent mandibular right second premolar tooth",
        "46": "Structure of permanent mandibular right first molar tooth",
        "47": "Structure of permanent mandibular right second molar tooth",
        "48": "Structure of permanent mandibular right third molar tooth",

        "55": "Structure of primary maxillary right second molar tooth",
        "54": "Structure of primary maxillary right first molar tooth",
        "53": "Structure of primary maxillary right canine tooth",
        "52": "Structure of primary maxillary right lateral incisor tooth",
        "51": "Structure of primary maxillary right central incisor tooth",

        "61": "Structure of primary maxillary left central incisor tooth",
        "62": "Structure of primary maxillary left lateral incisor tooth",
        "63": "Structure of primary maxillary left canine tooth",
        "64": "Structure of primary maxillary left first molar tooth",
        "65": "Structure of primary maxillary left second molar tooth",

        "71": "Structure of primary mandibular left central incisor tooth",
        "72": "Structure of primary mandibular left lateral incisor tooth",
        "73": "Structure of primary mandibular left canine tooth",
        "74": "Structure of primary mandibular left first molar tooth",
        "75": "Structure of primary mandibular left second molar tooth",
        "81": "Structure of primary mandibular right central incisor tooth",
        "82": "Structure of primary mandibular right lateral incisor tooth",
        "83": "Structure of primary mandibular right canine tooth",
        "84": "Structure of primary mandibular right first molar tooth",
        "85": "Structure of primary mandibular right second molar tooth",


    }

    const getFillColor = (toothNumber) => {
        const choice = formchoiceGigi?.choiceGigi?.trim()?.toLowerCase();
        const selectedSet = TOOTH_SETS[choice] || [];

        const isSelected = selectedSet.includes(toothNumber);
        const isColored = coloredTeeth.includes(toothNumber);
        const hasDebris = getDataDebrisIndex?.[toothNumber]?.length > 0;

        if (isSelected || isColored || hasDebris) {
            return "#ADD8E6";
        }

        return "white";
    };
    const handleToothClick = (id, position) => {
        if (visibleOdontogram) {
            setPositionTooth(position)
            setSelectedTooth(id);
            setShowModal(true);

            setColoredTeeth((prev) => {
                if (prev.includes(id)) {
                    return prev.filter((toothId) => toothId !== id);
                } else {
                    return [...prev, id];
                }
            });

            if (toothPosition) {
                toothPosition((prev) => ({
                    ...prev,
                    [id]: position,
                }));
            }
        }
    };

    const handleDeleteDebrisIndex = () => {
        setGetDebrisIndex([]);
        setColoredTeeth([]);
        setDebrisPerTooth({});
        setSelectedTooth(null);


        GetResponseDataDebrisIndex()
    };


    useEffect(() => {
        // setiap kali state berubah, kirim ke parent
        if (onDataChange) {
            onDataChange(getDebrisIndex);
        }
    }, [getDebrisIndex]);

    useEffect(() => {
        if (onChangeDebrisPerTooth) {
            onChangeDebrisPerTooth(getDataDebrisIndex);
        }
    }, [getDataDebrisIndex]);

    useEffect(() => {
        if (onDebrisChange) {
            onDebrisChange(getDataChoiceDebrisIndex, selectedTooth);
        }
    }, [getDataChoiceDebrisIndex]);

    return (
        <>
            <Button
                variant={visibleOdontogram ? "success" : "primary"}
                size="sm"
                className="mb-2"
                onClick={() => {
                    const choice = formchoiceGigi?.choiceGigi?.trim()?.toLowerCase();
                    if (choice === "satu_gigi" || choice === "per_gigi") {
                        setVisibleOdontogram(!visibleOdontogram);
                        return;
                    }

                    const selectedTeeth = TOOTH_SETS[choice];

                    if (selectedTeeth && selectedTeeth.length > 0) {
                        setColoredTeeth(selectedTeeth);
                        setShowModal(true);
                    } else {
                        swal({
                            title: "Tidak ditemukan",
                            text: `Pilihan "${choice}" tidak valid.`,
                            icon: "warning",
                            timer: 2500,
                            buttons: false
                        });
                    }
                }}
            >
                Pilih Gigi untuk Debris Index
            </Button>
            <Button
                variant="danger"
                size="sm"
                className="mb-2 ms-2"
                onClick={handleDeleteDebrisIndex}
            >
                Hapus Debris Index
            </Button>


            {formchoiceGigi?.choiceGigi === "satu_gigi" || formchoiceGigi?.choiceGigi === "ra_rb_full" || formchoiceGigi?.choiceGigi === "ra_rb_dewasa" ||
                formchoiceGigi?.choiceGigi === "ra_dewasa_anak" || formchoiceGigi?.choiceGigi === "ra_dewasa" || formchoiceGigi?.choiceGigi === "ra_anak" ||
                formchoiceGigi?.choiceGigi === "rb_dewasa_anak" || formchoiceGigi?.choiceGigi === "rb_dewasa" || formchoiceGigi?.choiceGigi === "rb_anak" ||
                formchoiceGigi?.choiceGigi === "ra_rb_anak" || formchoiceGigi?.choiceGigi === "regio_1" || formchoiceGigi?.choiceGigi === "regio_2" ||
                formchoiceGigi?.choiceGigi === "regio_3" || formchoiceGigi?.choiceGigi === "regio_4" || formchoiceGigi?.choiceGigi === "regio_5" ||
                formchoiceGigi?.choiceGigi === "regio_6" || formchoiceGigi?.choiceGigi === "regio_7" || formchoiceGigi?.choiceGigi === "regio_8" ?
                <Col className="mt-2" xl='12' sm='12' style={{ padding: "0px 0px", fontSize: "12px" }} >

                    {/* Gigi Atas Dewasa */}
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("18", "Structure of permanent maxillary right third molar tooth")}>
                                <div style={{ textAlign: "center" }}>18</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) => renderToothPolygonDebrisIndex(points, "18", getFillColor("18")))}
                                </svg>
                            </div>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("17", "Structure of permanent maxillary right second molar tooth")}>
                                <div style={{ textAlign: "center" }}>17</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) => renderToothPolygonDebrisIndex(points, "17", getFillColor("17")))}
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("16", "Structure of permanent maxillary right first molar tooth")}>
                                <div style={{ textAlign: "center" }}>16</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "16", getFillColor("16"))
                                    )}
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("15", "Structure of permanent maxillary right second premolar tooth")}>
                                <div style={{ textAlign: "center" }}>15</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "15", getFillColor("15"))
                                    )}
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("14", "Structure of permanent maxillary right first premolar tooth")}>
                                <div style={{ textAlign: "center" }}>14</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "14", getFillColor("14"))
                                    )}
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("13", "Structure of permanent maxillary right canine tooth")}>
                                <div style={{ textAlign: "center" }}>13</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["13"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "13", getFillColor("13"))
                                        )}
                                    </g>
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("12", "Structure of permanent maxillary right lateral incisor tooth")}>
                                <div style={{ textAlign: "center" }}>12</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["12"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "12", getFillColor("12"))
                                        )}
                                    </g>
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("11", "Structure of permanent maxillary right central incisor tooth")}>
                                <div style={{ textAlign: "center" }}>11</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["11"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "11", getFillColor("11"))
                                        )}
                                    </g>
                                </svg>
                            </div>
                        </div>

                        <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("21", "Structure of permanent maxillary left central incisor tooth")}>
                                <div style={{ textAlign: "center" }}>21</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["21"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "21", getFillColor("21"))
                                        )}
                                    </g>
                                </svg>
                            </div>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("22", "Structure of permanent maxillary left lateral incisor tooth")}>
                                <div style={{ textAlign: "center" }}>22</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["22"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "22", getFillColor("22"))
                                        )}
                                    </g>
                                </svg>
                            </div>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("23", "Structure of permanent maxillary left canine tooth")}>
                                <div style={{ textAlign: "center" }}>23</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["23"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "23", getFillColor("23"))
                                        )}
                                    </g>
                                </svg>
                            </div>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("24", "Structure of permanent maxillary left first premolar tooth")}>
                                <div style={{ textAlign: "center" }}>24</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "24", getFillColor("24"))
                                    )}
                                </svg>
                            </div>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("25", "Structure of permanent maxillary left second premolar tooth")}>
                                <div style={{ textAlign: "center" }}>25</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "25", getFillColor("25"))
                                    )}
                                </svg>
                            </div>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("26", "Structure of permanent maxillary left first molar tooth")}>
                                <div style={{ textAlign: "center" }}>26</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "26", getFillColor("26"))
                                    )}
                                </svg>
                            </div>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("27", "Structure of permanent maxillary left second molar tooth")}>
                                <div style={{ textAlign: "center" }}>27</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "27", getFillColor("27"))
                                    )}
                                </svg>
                            </div>
                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("28", "Structure of permanent maxillary left third molar tooth")}>
                                <div style={{ textAlign: "center" }}>28</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "28", getFillColor("28"))
                                    )}
                                </svg>
                            </div>
                        </div>
                    </div>

                    {/* Gigi Atas Anak */}
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("55", "Structure of deciduous maxillary right second molar tooth")}>
                                <div style={{ textAlign: "center" }}>55</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "55", getFillColor("55"))
                                    )}
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("54")}>
                                <div style={{ textAlign: "center" }}>54</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "54", getFillColor("54", "Structure of deciduous maxillary right first molar tooth"))
                                    )}
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("53", "Structure of deciduous maxillary right canine tooth")}>
                                <div style={{ textAlign: "center" }}>53</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["53"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "53", getFillColor("53"))
                                        )}
                                    </g>
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("52", "Structure of deciduous maxillary right lateral incisor tooth")}>
                                <div style={{ textAlign: "center" }}>52</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["52"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "52", getFillColor("52"))
                                        )}
                                    </g>
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("51", "Structure of deciduous maxillary right central incisor tooth")}>
                                <div style={{ textAlign: "center" }}>51</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["51"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "51", getFillColor("51"))
                                        )}
                                    </g>
                                </svg>
                            </div>

                        </div>

                        <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("61", "Structure of deciduous maxillary left central incisor tooth")}>
                                <div style={{ textAlign: "center" }}>61</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["61"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "61", getFillColor("61"))
                                        )}
                                    </g>
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("62", "Structure of deciduous maxillary left lateral incisor tooth")}>
                                <div style={{ textAlign: "center" }}>62</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["62"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "62", getFillColor("62"))
                                        )}
                                    </g>
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("63", "Structure of deciduous maxillary left canine tooth")}>
                                <div style={{ textAlign: "center" }}>63</div>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["63"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "63", getFillColor("63"))
                                        )}
                                    </g>
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("64", "Structure of deciduous maxillary left first molar tooth")}>
                                <div style={{ textAlign: "center" }}>64</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "64", getFillColor("64"))
                                    )}
                                </svg>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("65", "Structure of deciduous maxillary left second molar tooth")}>
                                <div style={{ textAlign: "center" }}>65</div>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "65", getFillColor("65"))
                                    )}
                                </svg>
                            </div>

                        </div>
                    </div>

                    {/* Gigi Bawah Anak */}
                    <div className="mt-2" style={{ display: "flex" }}>
                        <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("85", "Structure of deciduous mandibular right second molar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "85", getFillColor("85"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>85</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("84", "Structure of deciduous mandibular right first molar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "84", getFillColor("84"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>84</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("83", "Structure of deciduous mandibular right canine tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["83"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "83", getFillColor("83"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>83</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("82", "Structure of deciduous mandibular right lateral incisor tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["82"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "82", getFillColor("82"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>82</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("81", "Structure of deciduous mandibular right central incisor tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["81"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "81", getFillColor("81"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>81</div>
                            </div>

                        </div>

                        <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("71", "Structure of deciduous mandibular left central incisor tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["71"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "71", getFillColor("71"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>71</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("72", "Structure of deciduous mandibular left lateral incisor tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["72"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "72", getFillColor("72"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>72</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("73", "Structure of deciduous mandibular left canine tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["73"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "73", getFillColor("73"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>73</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("74", "Structure of deciduous mandibular left first molar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "74", getFillColor("74"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>74</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("75", "Structure of deciduous mandibular left second molar tooth")}>

                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "75", getFillColor("75"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>75</div>
                            </div>


                        </div>
                    </div>

                    {/* Gigi Bawah Dewasa */}
                    <div style={{ display: "flex" }}>
                        <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "30px" }}>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("48")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "48", getFillColor("48", "Structure of permanent mandibular right third molar tooth"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>48</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("47", "Structure of permanent mandibular right second molar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "47", getFillColor("47"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>47</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("46", "Structure of permanent mandibular right first molar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "46", getFillColor("46"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>46</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("45", "Structure of permanent mandibular right second premolar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "45", getFillColor("45"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>45</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("44", "Structure of permanent mandibular right first premolar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "44", getFillColor("44"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>44</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("43", "Structure of permanent mandibular right canine tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["43"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "43", getFillColor("43"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>43</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("42", "Structure of permanent mandibular right lateral incisor tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["42"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "42", getFillColor("42"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>42</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("41", "Structure of permanent mandibular right central incisor tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["41"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "41", getFillColor("41"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>41</div>
                            </div>

                        </div>

                        <div style={{ flex: "50%", display: "flex", justifyContent: "start", paddingLeft: "30px" }}>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("31", "Structure of permanent mandibular left central incisor tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["31"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "31", getFillColor("31"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>31</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("32", "Structure of permanent mandibular left lateral incisor tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["32"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "32", getFillColor("32"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>32</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("33", "Structure of permanent mandibular left canine tooth")}>
                                <svg width={42} height={42}>
                                    <g>
                                        {customToothShapes["33"].map(({ points }) =>
                                            renderToothPolygonDebrisIndex(points, "33", getFillColor("33"))
                                        )}
                                    </g>
                                </svg>
                                <div style={{ textAlign: "center" }}>33</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("34", "Structure of permanent mandibular left first premolar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "34", getFillColor("34"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>34</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("35", "Structure of permanent mandibular left second premolar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "35", getFillColor("35"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>35</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("36", "Structure of permanent mandibular left first molar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "36", getFillColor("36"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>36</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("37", "Structure of permanent mandibular left second molar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "37", getFillColor("37"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>37</div>
                            </div>

                            <div style={{ width: "42px", margin: "5px" }} onClick={() => handleToothClick("38", "Structure of permanent mandibular left third molar tooth")}>
                                <svg width="42" height="42" viewBox="0 0 42 42">
                                    {toothShapes.map(({ points }) =>
                                        renderToothPolygonDebrisIndex(points, "38", getFillColor("38"))
                                    )}
                                </svg>
                                <div style={{ textAlign: "center" }}>38</div>
                            </div>
                        </div>

                    </div>

                    <ModalDebrisIndex
                        formchoiceGigi={formchoiceGigi}
                        showModal={showModal}
                        setShowModal={setShowModal}
                        selectedTooth={selectedTooth}
                        positionTooth={positionTooth}
                        onDataChange={onDataChange}

                        setDebrisPerTooth={setDebrisPerTooth}
                        visibleOdontogram={visibleOdontogram}
                        setVisibleOdontogram={setVisibleOdontogram}
                        onSave={(selectedDebris) => {
                            setDebrisPerTooth((prev) => {
                                const newState = { ...prev };
                                const choice = formchoiceGigi?.choiceGigi?.trim()?.toLowerCase();

                                if (choice === "satu_gigi" || choice === "per_gigi") {
                                    if (selectedTooth) {
                                        newState[selectedTooth] = selectedDebris.map((item) => item.id);
                                    }
                                } else {

                                    const selectedTeeth = TOOTH_SETS[choice] || [];
                                    selectedTeeth.forEach((tooth) => {
                                        const position = TOOTH_POSITIONS[tooth] || null;
                                        newState[tooth] = selectedDebris.map((item) => ({
                                            id: item.id,
                                            display_name: item.display_name,
                                            position: position,
                                        }));
                                    });

                                    setGetDataChoiceDebrisIndex(newState)
                                    return newState;
                                }

                                setGetDataChoiceDebrisIndex(newState)
                                return newState;
                            });
                        }}


                    />
                </Col>
                :
                <></>
            }
        </>
    )
}